export const BILLING_COMPANIES = {
    CompMed:{
        name: "CompMed",
        adt: "compMed_ADT",
        dft: "compMed_DFT"
    },
    Coronis:{
        name: "Coronis",
        adt: "coronis_ADT",
        dft: "coronis_DFT"
    }
}